import React from 'react';

const MeetTheFounders = () => {
  // Custom scrollbar styles for mobile
  const scrollbarStyles = `
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    .scrollbar-hide {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  `;
  // Professional Dog Portrait Components
  const JoeyPortrait = () => (
<img src="/assets/f1.png" alt="Zelda" className="w-full object-cover h-full" />
  );

  const ChandlerPortrait = () => (
<img src="/assets/f2.png" alt="Zelda" className="w-full object-cover h-full" />
  );

  const ZeldaPortrait = () => (
    <img src="/assets/f3.png" alt="Zelda" className="w-full object-cover h-full" />
  );

  const founders = [
    {
      id: 1,
      name: 'Joey',
      title: 'CEO',
      portrait: <JoeyPortrait />
    },
    {
      id: 2,
      name: 'Chandler',
      title: 'CEO',
      portrait: <ChandlerPortrait />
    }
  ];

  return (
    <>
      <style>{scrollbarStyles}</style>
      <section className=" py-[32px] md:py-[60px]">
        <div className=" px-[20px] md:px-[60px] lg:px-[120px]">
        {/* Section Header */}
        <div className="flex items-center justify-start mb-[20px]">
          <h2 className="text-[20px] font-medium text-black ">Meet the founders</h2>
          {/* Horn/Megaphone Icon */}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <g clip-path="url(#clip0_250_22723)">
    <path d="M18 8.1394C18.7956 8.1394 19.5587 8.45547 20.1213 9.01808C20.6839 9.58069 21 10.3438 21 11.1394C21 11.9351 20.6839 12.6981 20.1213 13.2607C19.5587 13.8233 18.7956 14.1394 18 14.1394" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 8.1394V19.1394C10 19.4046 9.89464 19.659 9.70711 19.8465C9.51957 20.034 9.26522 20.1394 9 20.1394H8C7.73478 20.1394 7.48043 20.034 7.29289 19.8465C7.10536 19.659 7 19.4046 7 19.1394V14.1394" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 8.13935L16.524 4.36935C16.6555 4.25986 16.8154 4.1901 16.9851 4.16826C17.1548 4.14641 17.3271 4.17338 17.482 4.246C17.6369 4.31863 17.7679 4.4339 17.8597 4.5783C17.9514 4.72271 18.0001 4.89027 18 5.06135V17.2174C18.0001 17.3884 17.9514 17.556 17.8597 17.7004C17.7679 17.8448 17.6369 17.9601 17.482 18.0327C17.3271 18.1053 17.1548 18.1323 16.9851 18.1104C16.8154 18.0886 16.6555 18.0188 16.524 17.9094L12 14.1394H4C3.73478 14.1394 3.48043 14.034 3.29289 13.8465C3.10536 13.6589 3 13.4046 3 13.1394V9.13935C3 8.87414 3.10536 8.61978 3.29289 8.43225C3.48043 8.24471 3.73478 8.13935 4 8.13935H12Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_250_22723">
      <rect width="24" height="24" fill="white" transform="translate(0 0.139404)"/>
    </clipPath>
  </defs>
</svg>
          {/* Bone Icon */}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <g clip-path="url(#clip0_174_2453)">
              <path d="M14.9999 3.13965C15.7955 3.13965 16.5586 3.45572 17.1212 4.01833C17.6838 4.58094 17.9999 5.344 17.9999 6.13965C18.4932 6.13954 18.979 6.2611 19.4141 6.49356C19.8493 6.72602 20.2204 7.06221 20.4945 7.47234C20.7687 7.88247 20.9375 8.35389 20.986 8.84484C21.0345 9.33579 20.9612 9.83112 20.7725 10.287C20.5838 10.7428 20.2856 11.1451 19.9044 11.4581C19.5231 11.7712 19.0705 11.9854 18.5867 12.0818C18.1028 12.1782 17.6027 12.1538 17.1306 12.0107C16.6584 11.8677 16.2289 11.6104 15.8799 11.2616L11.1219 16.0196C11.4653 16.3633 11.7201 16.7853 11.8644 17.2492C12.0086 17.7131 12.0381 18.2051 11.9502 18.6829C11.8623 19.1607 11.6596 19.61 11.3597 19.9922C11.0598 20.3744 10.6715 20.678 10.2283 20.877C9.78506 21.0759 9.30015 21.1643 8.81524 21.1344C8.33033 21.1045 7.85993 20.9573 7.44448 20.7055C7.02903 20.4536 6.68096 20.1046 6.4302 19.6885C6.17944 19.2724 6.03349 18.8016 6.0049 18.3166V18.1396H5.8289C5.34373 18.1112 4.87274 17.9653 4.45643 17.7146C4.04013 17.4638 3.69098 17.1157 3.43903 16.7001C3.18707 16.2845 3.03986 15.8139 3.01005 15.3288C2.98023 14.8437 3.06871 14.3587 3.26788 13.9154C3.46705 13.472 3.77093 13.0838 4.15339 12.7839C4.53586 12.484 4.98544 12.2816 5.46347 12.194C5.94151 12.1063 6.43367 12.1361 6.89763 12.2808C7.36158 12.4256 7.78344 12.6808 8.1269 13.0246L12.8849 8.26665C12.4652 7.84721 12.1793 7.31272 12.0634 6.73078C11.9474 6.14885 12.0067 5.5456 12.2336 4.99734C12.4605 4.44907 12.8449 3.98042 13.3382 3.65064C13.8315 3.32086 14.4115 3.14478 15.0049 3.14465L14.9999 3.13965Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_174_2453">
                <rect width="24" height="24" fill="white" transform="translate(0 0.139648)"/>
              </clipPath>
            </defs>
          </svg>
        </div>

        {/* Founders Grid */}
        <div className="w-full ">
          {/* Mobile: Horizontal Scrollable */}
          <div className=" flex space-x-[8px] overflow-x-auto pb-[32px] -mx-4 px-[16px] scrollbar-hide">
            {founders.map((founder) => (
              <div key={founder.id} className="text-start border border-[1px] border-[#E5E5E5] p-[10px] min-w-[120px] flex-shrink-0">
                {/* Professional Portrait - Small on Mobile */}
                <div className="w-full bg-white">
                  <div className=" md:w-full h-[40vh] w-[70vw] aspect[4/3]">
                    {founder.portrait}
                  </div>
                </div>

                {/* Founder Info */}
                <div className='flex flex-col bg-white p-[12px] items-start justify-start'>
                  <h3 className="text-[18px] font-bold text-black leading-none">{founder.name}</h3>
                  <p className="text-[14px] text-black font-light">{founder.title}</p>
                </div>
              </div>
            ))}
          </div>

         
        </div>

        {/* Description */}
        <div className="text-left">
          <p className="text-[40px] md:text-[50px] text-[#b7b7b7] font-normal py-[32px] leading-[1.2] tracking-[-2.5px]">
            <span className="">Book for Paws is your go-to place to fetch pet-friendly stays, wag-worthy events, tail-trail tours & more. One platform, endless </span>
            <span className="text-[#4B4B4B] font-normal">pawsibilities!</span>
            <span className="ml-2">🐾</span>
          </p>
        </div>
              </div>
      </section>
    </>
  );
};

export default MeetTheFounders; 